export const timezoneOffset = (date: string | Date): Date => new Date(new Date(date).getTime() + new Date().getTimezoneOffset() * 60 * 1000);
